import { TableDefinition } from "features/shared/types/table";
import { User } from "../types/access";

const ACCESS_MANAGEMENT_TABLE: TableDefinition<User> = {
    rowTemplate: [
        {
            header: "Email",
            accessor: "email",
            flex: 1,
            isShown: true,
        },
        {
            header: "Name",
            accessor: "displayName",
            flex: 1,
            isShown: true,
        },
        {
            header: "Role",
            accessor: "role",
            flex: 1,
            isShown: true,
        },
    ],
    defaultSortKey: "email",
};

export default ACCESS_MANAGEMENT_TABLE;
